import { TicketStatus } from '@/types/enums';

function getTicketStatus(status: TicketStatus): string {
  if (status === TicketStatus.Waiting) return '待您确认';
  if (status === TicketStatus.Dealing) return '正在为您处理';
  if (status === TicketStatus.Closed) return '工单已关闭';
  return '全部';
}

export default getTicketStatus;
